/**
 * @param {string|null} type
 * @returns {*}
 */
function getCookieSettings (type = null) {
  const settings = {
    default: { maxAge: 90000000 * 30, httpOnly: false },
    op_user_id: { maxAge: 90000000 * 60, httpOnly: false },
    access_token: { maxAge: 90000000 * 30, httpOnly: true }
  }

  return settings[type] || settings.default
}

module.exports = { getCookieSettings }
